import React from "react";
import Sidebar from "../sidebar/Sidebar";
import { Outlet } from "react-router";
import Header from "../header/Header";

const Layout = () => {
  const [isOpen, setOpen] = React.useState(false);
  return (
    <div className="dashboard-home flex h-full">
      <div
        className={`dashoboard-sidebar w-[300px] grow primary-gradient h-full ${
          isOpen ? "active" : ""
        }`}
      >
        <Sidebar />
      </div>
      <div className="dashboard-content-holder w-[100%] grow h-full relative">
        <Header isOpen={isOpen} setOpen={setOpen} />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
